/* eslint-disable import/prefer-default-export */
import React from 'react';
import {PageContextProvider} from './src/data/page-context';
import {SEO} from './src/components/atoms';
import {WithApollo} from './src/data/apollo-config';
import {ApolloLoaderContextProvider} from './src/data/apollo-loading-context';

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({element}) => {
  return (
    <ApolloLoaderContextProvider>
      <WithApollo>{element}</WithApollo>
    </ApolloLoaderContextProvider>
  );
};

export const wrapPageElement = incoming => {
  const {element, props} = incoming;
  const protocol = process.env.GATSBY_DOMAIN_ROOT.startsWith('localhost') ? 'http' : 'https';
  return (
    <PageContextProvider
      pageContext={{
        signIn: props.location.search === '?signin',
        url: `${protocol}://${process.env.GATSBY_DOMAIN_ROOT}${props.location.pathname}`,
        ...props.pageContext,
      }}
    >
      <SEO>{element}</SEO>
    </PageContextProvider>
  );
};

export const onClientEntry = () => {};

export const onInitialClientRender = () => {};
